import { OrangeButton } from 'components/Button';
import ConfirmPasswordModal from 'components/ConfirmPasswordModal';
import About from 'containers/MyAccountPage/About';
import messages from 'containers/MyAccountPage/messages';
import MyPreferences from 'containers/MyAccountPage/MyPreferences';
import PersonalInfo from 'containers/MyAccountPage/PersonalInfo';
import validationSchema from 'containers/MyAccountPage/validationSchema';
import { FormikProps, withFormik } from 'formik';
import { translate } from 'helpers/intl';
import { get, isEmpty } from 'lodash';
import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { ProfileSettingsInfoType } from 'store/user/types';
import { handleSubmit as _handleSubmit, mapPropsToValues } from './utils';

const ChangePasswordForm = (
  props: {
    profileSettingsInfo: ProfileSettingsInfoType;
    isLoading: boolean;
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    profileSettingsInfo,
    handleSubmit,
  } = props;

  const [isConfirmPasswordModalOpen, setIsConfirmPasswordModalOpen] = useState(
    false,
  );

  function handleSubmitPassword() {
    handleSubmit();
    setIsConfirmPasswordModalOpen(false);
  }

  function saveUpdatesDisable() {
    return (
      isEmpty(touched) &&
      get(profileSettingsInfo, 'phone') === get(values, 'phoneNumber') &&
      get(profileSettingsInfo, 'email') === get(values, 'email') &&
      get(profileSettingsInfo, 'birthday') === get(values, 'bday')
    );
  }

  return (
    <form>
      <PersonalInfo
        firstName={profileSettingsInfo.firstName}
        lastName={profileSettingsInfo.lastName}
        cin={profileSettingsInfo.cin}
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        touched={touched}
        errors={errors}
      />
      <MyPreferences handleChange={handleChange} values={values} />
      <About />
      <OrangeButton
        variant="contained"
        onClick={() => setIsConfirmPasswordModalOpen(true)}
        disabled={saveUpdatesDisable()}
      >
        {translate(get(messages, 'saveChanges'), props)}
      </OrangeButton>
      <ConfirmPasswordModal
        isOpen={isConfirmPasswordModalOpen}
        handleClose={() => setIsConfirmPasswordModalOpen(false)}
        error={touched.password && errors.password}
        helperText={touched.password && errors.password}
        handleChange={handleChange}
        handleBlur={handleBlur}
        value={values.password}
        handleSubmit={handleSubmitPassword}
        isLoading={props.isLoading}
      />
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  profileSettingsInfo: ProfileSettingsInfoType;
  updateProfileSettingsInfo: Function;
  isLoading: boolean;
}

interface FormValues {
  birthday: string;
  phoneNumber: string;
  email: string;
  password: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues,
  validationSchema,
  handleSubmit: _handleSubmit,
})(ChangePasswordForm);

export default injectIntl(Form);
